.m-checkingVerificationIcon-e0808d711b{width:24px;height:24px}